import { List } from '@mui/material'

import { MobileBottomLayout, PaginationButtons } from 'src/components'
import { IScanRespDto } from 'src/types'
import { GridItem } from './item.component'
import { getUserIdAndRolesFromToken } from 'src/common/utils'

interface IProps {
  data?: IScanRespDto[]
  isScaner: boolean
  isFirstItemOpen: boolean
}

export const ScansGrid = ({ data, isScaner, isFirstItemOpen }: IProps) => {
  return (
    <>
      <List sx={{ width: '100%' }}>
        {data?.map((item) => (
          <GridItem
            item={item}
            key={item.id}
            isScaner={isScaner}
            isOpen={isFirstItemOpen && item.id === data?.[0].id}
            userRole={item.account_role_for_user}
            currentUserRoleAndId={getUserIdAndRolesFromToken()}
          />
        ))}
      </List>
      <MobileBottomLayout>
        <PaginationButtons buttonsOnly />
      </MobileBottomLayout>
    </>
  )
}
